import React, { Component } from 'react';
import { SlFormEntryRow, SlYesNo, SlSectionTitle } from '../editors'
import { metadataService, userService } from '../../_services'
import PropTypes from 'prop-types';

export class LanguagePreferences extends Component {
    constructor(props) {
        super(props);

        this.state = {
            formValue: {
                selectedLanguage: userService.getUserLanguage()
            },
            fieldErrors: [],
        };

        this.handleInput = this.handleInput.bind(this);
        this.handleChangeState = this.handleChangeState.bind(this);
    }

    componentDidMount() {

    }

    handleOnBlur = ({ target: { name, value } }) => {
        this.setState({ visited: true });
    }

    handleInput = ({ target: { name, value } }) => {

        const formValue = { ...this.state.formValue, [metadataService.jsonFieldName(name)]: value };
        let newState = {
            ...this.state,
            formValue: formValue
        };

        if (name === "SelectedLanguage") {
            userService.setUserLanguage(value);
        }

        this.handleChangeState(newState);

        this.props.onChange({ target: { name: this.props.name, value: value } });
    };

    handleChangeState(newState){
        this.setState(newState)
    }

    render() {
        return (
            <div>
                <SlSectionTitle sectionName="LanguagePrefrence" />
                <SlYesNo name="SelectedLanguage"
                    value={this.state.formValue.selectedLanguage}
                    disabled={this.props.readOnly}
                    trueValue='en' falseValue='es' trueText={metadataService.getLabel("English")} falseText={metadataService.getLabel("Spanish")}
                    onChange={this.handleInput} />
            </div>
        );
    }
}
//Define prop types
LanguagePreferences.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    readOnly: PropTypes.bool
}

LanguagePreferences.defaultProps = {
    readOnly: false
}


// WEBPACK FOOTER //
// ./src/components/subcomponents/LanguagePreferences.js